import { createContext, useContext } from 'react';
// Provide a default value that matches the Context's type to avoid runtime errors
// and simplify consumer logic (no need to check for undefined context).
const defaultPdfContentContextValue = {
    identity: null,
    pdfArrayBuffer: null,
    isLoading: false,
    error: null,
};
export const CurrentPdfDocumentContentContext = createContext(defaultPdfContentContextValue);
export function useCurrentPdfDocumentContentContext() {
    const context = useContext(CurrentPdfDocumentContentContext);
    // No longer need to check for undefined if a default value is always provided.
    // Consumers can rely on the default value structure.
    // if (context === undefined) {
    //   throw new Error('useCurrentPdfDocumentContentContext must be used within a CurrentPdfDocumentContentProvider');
    // }
    return context;
}
//# sourceMappingURL=CurrentPdfDocumentContentContext.js.map